export const commercialGeneralTemplate = [
  { field: 'id',                      label: 'Transaction ID'           }, // general
  { field: 'machine.machineUUID',     label: 'Machine UUID'             }, // general
  { field: 'date',                    label: 'Date'                     }, // general
  { field: 'time',                    label: 'Time'                     }, // general
  { field: 'product.name',            label: 'Product Name'             }, // general
  { field: 'product.categoryName',    label: 'Product Category'         }, // general
  { field: 'product.sku',             label: 'Product Sku'              }, // general
  { field: 'product.serialNumber',    label: 'Product Serial No'        }, // general
  { field: 'product.formattedSlotId', label: 'Slot'                     }, // general
  { field: 'amount',                  label: 'Transaction Amount (RM)'  }, // general
  { field: 'status',                  label: 'Transaction Status'       }, // general
  { field: 'payment.paymentGateway',  label: 'Payment Gateway'          }, // general
];

export const ipayTemplate = [
  { field: 'payment.ewalletType',                 label: 'Ewallet Type'   }, // Ipay
  { field: 'payment.refNo',                       label: 'Reference No'   }, // Ipay
  { field: 'payment.transactionId',               label: 'Transaction Id' }, // Ipay
  { field: 'payment.remark',                      label: 'Remark'         }, // Ipay
  { field: 'payment.ipay88VoidTransactionResult', label: 'Refund Status'  }, // Ipay
  { field: 'payment.refundAmount',                label: 'Refund Amount'  }, // Ipay
];

export const cashCoinTemplate = [
  { field: 'cashInDetails.cashInTypeAndCount.["0.1"]',    label: '10 Cent (CashIn)'     }, // Cash
  { field: 'cashInDetails.cashInTypeAndCount.["0.2"]',    label: '20 Cent (CashIn)'     }, // Cash
  { field: 'cashInDetails.cashInTypeAndCount.["0.5"]',    label: '50 Cent (CashIn)'     }, // Cash
  { field: 'cashInDetails.cashInTypeAndCount.["1.0"]',    label: '1 Ringgit (CashIn)'   }, // Cash
  { field: 'cashInDetails.cashInTypeAndCount.["5.0"]',    label: '5 Ringgit (CashIn)'   }, // Cash
  { field: 'cashInDetails.cashInTypeAndCount.["10.0"]',   label: '10 Ringgit (CashIn)'  }, // Cash
  { field: 'cashInDetails.cashInTypeAndCount.["20.0"]',   label: '20 Ringgit (CashIn)'  }, // Cash
  { field: 'cashInDetails.cashInTotal',                   label: 'Total (CashIn)'       }, // Cash
  { field: 'cashOutDetails.cashOutTypeAndCount.["0.1"]',  label: '10 Cent (CashOut)'    }, // Cash
  { field: 'cashOutDetails.cashOutTypeAndCount.["0.2"]',  label: '20 Cent (CashOut)'    }, // Cash
  { field: 'cashOutDetails.cashOutTypeAndCount.["0.5"]',  label: '10 Cent (CashOut)'    }, // Cash
  { field: 'cashOutDetails.cashOutTotal',                 label: 'Total (CashOut)'      }, // Cash
];

export const terminalTemplate = [
  { field: 'payment.terminalSaleDetail.refNo',          label: 'Paywave ReferenceNo'    }, // Terminal
  { field: 'payment.terminalSaleDetail.transactionId',  label: 'Paywave Transaction Id' }, // Terminal
  { field: 'payment.terminalSaleDetail.responseCode',   label: 'Paywave Status'         }, // Terminal
];

export const vircleTemplate = [
  { field: 'payment.virclePaymentDetail.paymentRequest.refNo',  label: 'Vircle ReferenceNo'         }, // vircle
  { field: 'payment.virclePaymentDetail.paymentResult.message', label: 'Vircle Transaction Status'  }, // vircle
  { field: 'payment.virclePaymentDetail.voidResult.message',    label: 'Vircle Void Status'         }, // vircle
];

export const oneUtamaTemplate = [
  { field: 'payment.refNo',                         label: 'Reference No'             },
  { field: 'payment.onePay.payment.transactionId',  label: '1Pay Transaction Id'      },
  { field: 'payment.onePay.payment.result',         label: '1Pay Transaction Status'  },
];

export const errorMessageTemplate = [{ field: 'error.message', label: 'Failed Message' }];

export const eventParamsTemplate = [
  { field: 'payment.params.name',   label: "Name"       }, 
  { field: 'payment.params.age',    label: "Age"        }, 
  { field: 'payment.params.gender', label: "Gender"     },
  { field: 'payment.params.mobile', label: "Phone No."  },
  { field: 'payment.params.email',  label: "Email"      },
];

export const mroGeneralTemplate = [           
  { field: 'id',                                  label: 'Transaction ID'               },
  { field: 'machine.machineUUID',                 label: 'Machine UUID'                 },
  { field: 'date',                                label: 'Date'                         },
  { field: 'time',                                label: 'Time'                         },
  { field: 'product.name',                        label: 'Product Name'                 },
  { field: 'product.priceCash',                   label: 'Product Price (RM)'           },
  { field: 'product.priceCredit',                 label: 'Product Price (Credit)'       },
  { field: 'product.categoryName',                label: 'Product Category'             },
  { field: 'product.sku',                         label: 'Product Sku'                  },
  { field: 'product.serialNumber',                label: 'Product Serial No'            },
  { field: 'product.formattedSlotId',             label: 'Slot'                         },
  { field: 'amount',                              label: 'Transaction Amount (Credit)'  },
  { field: 'status',                              label: 'Transaction Status'           },
  { field: 'employee.fullName',                   label: 'Employee Name'                },
  { field: 'employee.employeeNumber',             label: 'Employee No'                  },
  { field: 'employee.cardNumber',                 label: 'Employee Card'                },
  { field: 'employee.department',                 label: 'Department'                   },
  { field: 'payment.params.project_id',           label: 'Project Id'                   },
  { field: 'payment.params.project_description',  label: 'Project Description'          },
  { field: 'error.message',                       label: 'Failed Message'               },
];

export const mroMachineDualModeTemplate = [
  { field: 'id',                                  label: 'Transaction ID'                 },
  { field: 'machine.machineUUID',                 label: 'Machine UUID'                   },
  { field: 'date',                                label: 'Date'                           },
  { field: 'time',                                label: 'Time'                           },
  { field: 'product.name',                        label: 'Product Name'                   },
  { field: 'product.priceCash',                   label: 'Product Price (RM)'             },
  { field: 'product.priceCredit',                 label: 'Product Price (Credit)'         },
  { field: 'product.categoryName',                label: 'Product Category'               },
  { field: 'product.sku',                         label: 'Product Sku'                    },
  { field: 'product.serialNumber',                label: 'Product Serial No'              },
  { field: 'product.formattedSlotId',             label: 'Slot'                           },
  { field: 'amount',                              label: 'Transaction Amount (RM/Credit)' },
  { field: 'status',                              label: 'Transaction Status'             },
  { field: 'payment.paymentGateway',              label: 'Payment Gateway'                },
  { field: 'payment.ewalletType',                 label: 'Ewallet Type'                   },
  { field: 'payment.refNo',                       label: 'Ipay ReferenceNo'               },
  { field: 'payment.transactionId',               label: 'Ipay Transaction Id'            },
  { field: 'payment.remark',                      label: 'Remark'                         },
  { field: 'payment.ipay88VoidTransactionResult', label: 'Refund Status'                  },
  { field: 'payment.refundAmount',                label: 'Refund Amount'                  },
  { field: 'employee.fullName',                   label: 'Employee Name'                  },
  { field: 'employee.employeeNumber',             label: 'Employee No'                    },
  { field: 'employee.cardNumber',                 label: 'Employee Card'                  },
  { field: 'employee.department',                 label: 'Department'                     },
  { field: 'payment.params.project_id',           label: 'Project Id'                     },
  { field: 'payment.params.project_description',  label: 'Project Description'            },
  { field: 'error.message',                       label: 'Failed Message'                 },
];

export const ErrorDetailList = [
  {
    category: 'Hardware',
    key: ['sensor got blocked'],
    message: 'sensor got blocked',
  },
  {
    category: 'Hardware',
    key: ['driver board went wrong', 'no item detect dropped'],
    message: 'Item Not Detect Dropped',
  },
  {
    category: 'Hardware',
    key: ['data does noe have 30 count'],
    message: 'Driver board communication went wrong',
  },
  {
    category: 'System',
    key: ['signature not match'],
    message: 'Signature not match',
  },
  {
    category: 'Customer',
    key: [
      'balance is not enough',
      'insufficient fund',
      'insufficient balance',
      'balance not sufficient',
      'USER NOT ENOUGH BALANCE',
    ],
    message: "Customer's e-wallet insufficient balance",
  },
  {
    category: 'Customer',
    key: [
      '40913:consumer presented code is expired',
      '40912:consumer presented code is invalid',
      'Payment code not found/expired',
      'Incorrect Barcode',
      'CODE IS SCANNED BEFORE',
      'Invalid / Expired Customer Token',
      'Payment code used/expired',
      'Invalid Barcode/QR',
      'auth code already used',
      'auth code illegal',
      'Awaiting user to pay',
    ],
    message: "Customer's presented code was invalid",
  },
  {
    category: 'Customer',
    key: ['Customer account is disabled by Alipay'],
    message: 'Customer account is diabled by Alipay ',
  },
  {
    category: 'Merchant / Ipay',
    key: [
      'Payment not allowed',
      'Payment Fail',
      'Payment Fail (PAYMENT_FAIL)',
      'Payment fail (00000000)',
      'Payment fail ()',
      'Payment Fail (INVALID_QR_CODE)',
      'Payment Fail (REQUEST_FORMAT_ERROR)',
      'Payment Fail (No Response - Payment)',
      'Payment Fail (PENDING_CUST_ACTION)',
      'Payment fail (20)',
      'Payment fail (57)',
      'Payment Fail (QRC_EXPIRED)',
      'The barcode or QR code scanned by cashiers is not the one',
      'Payment Fail (KEY_EXPIRED)',
      'Payment fail (NOT_SUPPORT_PAYMENT_INST)',
    ],
    message: 'Payment was not allowed by payment gateway',
  },
  {
    category: 'System',
    key: [
      'UnknownHostException',
      'SocketTimeoutException',
      "Element 'head' does not have a match in class com.vechnology.ve.models.payment.data.ResponseEnvelope",
      'unexpected end of stream on Connectunexpected end of stream on Connection',
      'ConnectException',
      'SSLHandshakeException',
      'Internal Connection Timeout',
    ],
    message: 'Network connection issue',
  },
  {
    category: 'Merchant / Ipay',
    key: [
      '5001:server_error',
      'Response result is null',
      'Product toggle is disabled for merchant',
      'there is risk for payment request',
      'System error',
      'A server error occurred',
      'Payment method not supported',
      'System interruption',
      '40983:amount exceeds periodically daily limit of MYR',
      'channel not enable',
    ],
    message: "Payment's gateway error",
  },
  {
    category: 'User',
    key: ['User Was Using Wrong Wallet'],
    message: 'User Was Using Wrong Wallet',
  },
];
